"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commentFragment = void 0;
exports.commentFragment = `
  fragment comment on Comment {
    id
    text
    timestamp
    userId
  }
`;
//# sourceMappingURL=comment.js.map